import { JDSCheckboxProps } from './generated';
import { useInputState } from '../jdsinputfield/logic';
import { useSwitch } from '../../hooks/switch';

export interface InputCheckboxProps extends Omit<JDSCheckboxProps, 'onClick'> {
  /**
   * @deprecated
   * Use `stateText`
   */
  stateConfig?: {
    errorText?: string;
    successText?: string;
    warningText?: string;
    requiredText?: string;
  };
  /**
   * @deprecated
   * We do not allow IDs on components. This will be removed
   */
  id?: string;
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (ev: React.MouseEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
}

export const withLogic =
  (
    Component: React.ComponentType<InputCheckboxProps>
  ): React.FC<InputCheckboxProps> =>
  (props: InputCheckboxProps) => {
    const { switchState, onChange } = useSwitch(props.checked);
    const { stateText, inputState } = useInputState(
      props.state,
      false,
      undefined,
      props.stateConfig,
      props.stateText
    );
    return (
      <Component
        {...{
          ...props,
          checked: switchState,

          _ariaChecked: props.indeterminate
            ? 'mixed'
            : switchState === true
            ? 'true'
            : 'false',
          _hasHelper: Boolean(props.helperText),
          state: inputState,
          stateText,
          onClick: (ev: React.MouseEvent<HTMLInputElement>) => {
            const target = {
              ...ev.target,
              value: props.value || '',
              checked: !props.indeterminate ? !switchState : switchState
            };
            const event = {
              ...ev,
              target
            };
            if (!props.indeterminate) {
              onChange?.(!switchState);
              props.onChange?.(event as any);
            }
            props.onClick?.(event as React.MouseEvent<HTMLInputElement>);
          }
        }}
      />
    );
  };
